import MoveManger from "../../../../gd/manager/move-manager"
import ProjectSession from "../../../../model2/project/project-session"
import Task from "../../../../model2/task/task";

type ModalMoveTo_commitParams = {
    projectsToMove  : ProjectSession[]
    tasksToMove     : Task[]

    targetProject   : ProjectSession
}

export default function ModalMoveTo_commitMultiMoveToFolder(params: ModalMoveTo_commitParams, onMoveCallback?: {(selectedProjectId?: ID): void} ) {
    const taskIds = _.map(params.tasksToMove, (task: Task) => task.id)
    const projectIds = _.map(params.projectsToMove, (project: ProjectSession) => project.id)

    MoveManger.moveMultiToProject(taskIds, projectIds, params.targetProject.id, () => {
        onMoveCallback?.(params.targetProject.id)
        gd.modal.hide()
    })
}